import styled from 'styled-components';

const Container = styled.div`
	position: fixed;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	padding: 40px;
	z-index: 100;
	background-color: rgba(0,0,0,0.3);
	cursor: pointer;
`;

const Image = styled.div`
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
	margin: 0;
	z-index: 1;
	transform: translate(0px, 0px) scale(1);
  transition: all 0.2s ease-out;
	overflow: hidden;
	display: block;
	width: 100%;
	height: 100%;
`;

const ImageDetailsContainer = styled.div`
	position: absolute;
	bottom: 8px;
	left: 50%;
	transform: translateX(-50%);
	height: 40px;
	display: flex;
	align-items: center;
`;

const ImageDetail = styled.a`
	background-color: white;
	border-radius: 20px;
	color: black;
	padding: 8px 16px;
	font-size: 14px;
	box-shadow: 0px 2px 16px -8px rgba(0,0,0,1);
	display: flex;
	align-items: center;

	span {
		margin-right: 8px;

		svg {
			fill: black;
		}
	}

	& + & {
		margin-left: 1rem;
	}
`;

export {
	Container,
	Image,
	ImageDetailsContainer,
	ImageDetail
}
